import medal from "assets/images/medal.svg"
import { Card, Icon } from "materia"
import type { PropsWithChildren, ReactNode } from "react"
import { FiestaLink, type FiestaLinkProps } from "utility-components"
import s from "./LeaderboardView.module.scss"

export const LeaderboardView = ({ children }: PropsWithChildren) => (
  <Card>
    <div className={s.view}>{children}</div>
  </Card>
)

type ScopeSelectProps = {
  value: string
  onChange: (value: string) => void
  header: string
  children: ReactNode
}
const Scopes = ({ children, value, onChange, header }: ScopeSelectProps) => (
  <div className={s.scopeSelect}>
    <div className={s.scopeSelect__wrapper}>
      <img src={medal} alt="" />
      <h1 className={s.scopeSelect__text}>{header}</h1>
    </div>
    <select
      onChange={(value) => onChange(value.target.value)}
      value={value}
      className={s.scopeSelect__select}
      aria-label="Select department"
    >
      {children}
    </select>
  </div>
)

type ScopeProps = {
  value: string
  children: ReactNode
}
const Scope = ({ value, children }: ScopeProps) => (
  <option value={value}>{children}</option>
)

const Leaderboards = ({ children }: PropsWithChildren) => (
  <ul className={s.leaderboards}>{children}</ul>
)

type LeaderboardProps = {
  link: FiestaLinkProps
  linkText: string
  title: string
  children: ReactNode
}
const Leaderboard = ({ link, title, children, linkText }: LeaderboardProps) => (
  <li className={s.leaderboard}>
    <div className={s.leaderboard__header}>
      <h2 className={s.leaderboard__title}>{title}</h2>
      <FiestaLink className={s.leaderboard__link} {...link}>
        <div className={s.leaderboard__linkText}>{linkText}</div>
        <Icon icon="Chevron" size="small" className={s.leaderboard__chevron} />
      </FiestaLink>
    </div>
    <ul className={s.leaderboard__entries}>{children}</ul>
  </li>
)

const Skeleton = () => <div className={s.skeleton} />

LeaderboardView.Scopes = Scopes
LeaderboardView.Scope = Scope
LeaderboardView.Leaderboards = Leaderboards
LeaderboardView.Leaderboard = Leaderboard
LeaderboardView.Skeleton = Skeleton
